import GokuDataGrid from '@/components/GokuDataGrid'
import CellDate from '@/components/GokuDataGrid/CellDate'
import { DocumentVersion } from '@/modules/Documents/types/reponse'
import { Attachment } from '@/modules/Upload/types'
import { ModalProps } from '@/types/shared'
import { useCallback } from 'react'
import { t } from 'i18next'
import toast from 'react-hot-toast'
import { Dialog, Preview, Title, Typogaphy } from 'vnetwork-ui'
import { useFilePreviewWithPresigned } from '@/hooks/useFilePreviewWithPresigned'

export interface DocumentModalProps extends ModalProps {
    title: string
    description: string
    versions: DocumentVersion[]
}

const DocumentModal: React.FC<DocumentModalProps> = ({
    onClose,
    open,
    title,
    description,
    versions,
}) => {
    const { openFilePreview } = useFilePreviewWithPresigned()

    const handlePreview = useCallback(
        async (attachment: Attachment) => {
            const path = attachment?.attachment_file_url
            if (!path) {
                toast.error('Không có file path')
                return
            }

            try {
                openFilePreview(attachment)
            } catch (error) {
                console.error('Failed to get presigned URL:', error)
            }
        },
        [openFilePreview]
    )

    return (
        <Dialog
            maxWidth="lg"
            onClose={onClose}
            open={open}
            title={title}
            children={
                <div className="space-y-2">
                    <Preview
                        content={description}
                        scrollElement={document.body}
                    />

                    <GokuDataGrid
                        columns={[
                            {
                                field: 'version',
                                headerName: t('version'),
                                flex: 1,
                            },
                            {
                                field: 'attachment_file_name',
                                headerName: 'attachment_file_name',
                                renderCell: ({ row }) => (
                                    <Typogaphy
                                        className="text-primary underline cursor-pointer"
                                        onClick={() =>
                                            handlePreview(row?.attachment)
                                        }
                                    >
                                        {row?.attachment?.attachment_file_name}
                                    </Typogaphy>
                                ),
                                width: 400,
                            },
                            {
                                field: 'created_at',
                                headerName: t('created_at'),
                                renderCell: ({ row }) => (
                                    <CellDate
                                        date={row?.created_at}
                                        scope="DD/MM/YYYY HH:mm"
                                    />
                                ),
                                flex: 1,
                            },
                        ]}
                        apiCall={async () => ({
                            results: versions,
                        })}
                        reactQueryKey={[
                            'document-modal',
                            versions
                                ?.map((version) => version?.version_id)
                                .join(','),
                        ].join('-')}
                        dataGridProps={{
                            getRowId: (row) => row?.version_id,
                            hideFooter: true,
                        }}
                        options={{
                            title: <Title title={t('document-version')} />,
                            showHideColumn: false,
                            showSearch: false,
                            pageSize: 10,
                        }}
                    />
                </div>
            }
        />
    )
}

export default DocumentModal
